/* eslint-disable */
/* prettier-ignore */
// Generated by `rushx codegen:possible-types` from the schema SDL
// (../../../graphql/src/**/*.graphql, src/client-schema.graphql). Do not edit.
export const possibleTypes: Record<string, string[]> = {
  "APIClientPayload": [
    "APIClient",
    "NotFoundError"
  ],
  "APIClientUsageStatisticsPayload": [
    "APIClientUsageStatistics",
    "NotFoundError"
  ],
  "AcceptInvitationPayload": [
    "EmailAlreadyMemberError",
    "EmptySuccess",
    "InvitationEmailMismatchError",
    "TwoFactorSetupRequiredError"
  ],
  "AccountCompleteEmailVerification": [
    "AccountCompleteEmailVerificationErrorJWTExpired",
    "AccountCompleteEmailVerificationResponse",
    "Error"
  ],
  "AccountInitiateEmailVerificationPayload": [
    "AccountInitiateEmailVerificationError",
    "AccountInitiateEmailVerificationResponse"
  ],
  "AccountRemovePayload": [
    "AccountRemoveError",
    "AccountRemoveResponse"
  ],
  "AccountSuspendResponse": [
    "Error",
    "Response"
  ],
  "AccountUnsuspendResponse": [
    "Error",
    "Response"
  ],
  "AccountUpdateRoleResponse": [
    "Error",
    "Response"
  ],
  "AddEntityNotePayload": [
    "AddEntityNoteResponse",
    "CoreWebAppCommonError"
  ],
  "AddNoteToPostPayload": [
    "AddNoteToPostSuccess",
    "InvalidInputError",
    "LimitReachedError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "AddOrUpdateDismissedObjectPayload": [
    "AddOrUpdateDismissedObjectError",
    "AddOrUpdateDismissedObjectResponse"
  ],
  "AddPostToContentItemPayload": [
    "AddPostToContentItemSuccess",
    "VoidMutationError"
  ],
  "AddPostToQueuePayload": [
    "LimitReachedError",
    "NotFoundError",
    "PostActionSuccess",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "AnonymousMediaAccessPayload": [
    "AnonymousMediaAccessSuccess",
    "InvalidInputError",
    "LimitReachedError"
  ],
  "ApprovePostPayload": [
    "LimitReachedError",
    "NotFoundError",
    "PostActionSuccess",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "Asset": [
    "DocumentAsset",
    "ImageAsset",
    "VideoAsset"
  ],
  "AuthorizeChannelsPayload": [
    "AuthorizeChannelsError",
    "AuthorizeChannelsResponse"
  ],
  "BackfillChannelAnalyticsPayload": [
    "BackfillChannelAnalyticsSuccess",
    "VoidMutationError"
  ],
  "BackfillChannelPostsAndAnalyticsPayload": [
    "BasicError",
    "MutationBasicResponse"
  ],
  "BackfillChannelUpdatesResponse": [
    "Error",
    "Response"
  ],
  "BackfillUpdatesForGridPayload": [
    "BackfillUpdatesForGridResponse",
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "BaseComment": [
    "CommentFromBuffer",
    "CommentFromThirdParty"
  ],
  "BaseDiscount": [
    "AmountDiscount",
    "PercentDiscount"
  ],
  "BaseResponse": [
    "Error",
    "Response"
  ],
  "Billing": [
    "MPBilling",
    "OBBilling"
  ],
  "BillingCreateCheckoutSessionPayload": [
    "BillingCreateCheckoutSessionResponse",
    "BillingError"
  ],
  "BillingCreateCustomerPortalSessionPayload": [
    "BillingCreateCustomerPortalSessionResponse",
    "BillingError"
  ],
  "BillingCreatedSetupIntentPayload": [
    "BillingCreateSetupIntentResponse",
    "BillingError"
  ],
  "BillingDetails": [
    "MobileBillingDetails",
    "WebBillingDetails"
  ],
  "BillingIncreaseSubscriptionQuantityByChannelIdsPayload": [
    "BillingError",
    "BillingResponse"
  ],
  "BillingStartTrialPayload": [
    "BillingError",
    "BillingResponse"
  ],
  "BillingUpdateCustomerPaymentMethodPayload": [
    "BillingError",
    "BillingResponse"
  ],
  "BillingUpdateSubscriptionPlanPayload": [
    "BillingError",
    "BillingUpdateSubscriptionPlanResponse"
  ],
  "BillingUpdateSubscriptionQuantityPayload": [
    "BillingError",
    "BillingUpdateSubscriptionPlanResponse"
  ],
  "BlockMutationResponse": [
    "BlockMutationSuccess",
    "CommonError"
  ],
  "BlocksMutationResponse": [
    "BlocksMutationSuccess",
    "CommonError"
  ],
  "CalendarsPayload": [
    "Calendar",
    "PublishingError"
  ],
  "CancelPostRecurrencePayload": [
    "PostActionSuccess",
    "VoidMutationError"
  ],
  "CancelTrialPayload": [
    "CancelTrialResponse",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "ChannelAnalyticsExportStatus": [
    "ChannelAnalyticsExportFailure",
    "ChannelAnalyticsExportProcessing",
    "ChannelAnalyticsExportSuccess"
  ],
  "ChannelAnalyticsLastUpdateAtPayload": [
    "Error",
    "Response"
  ],
  "ChannelAuthorizationPayload": [
    "ChannelAuthorizationError",
    "ChannelAuthorizationResponse"
  ],
  "ChannelAuthorizationUrlPayload": [
    "ChannelAuthorizationUrlError",
    "ChannelAuthorizationUrlResponse"
  ],
  "ChannelConnectionListPayload": [
    "ChannelConnectionListResponse",
    "ChannelConnectionNoChannelsError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "ChannelConnectionRefreshPayload": [
    "ChannelConnectionCannotStealChannelError",
    "ChannelConnectionNoChannelsError",
    "ChannelConnectionRefreshResponse",
    "ChannelConnectionRefreshWrongAccountError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "ChannelGroupPayload": [
    "ChannelGroup",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "ChannelGroupsPayload": [
    "ChannelGroupsResponse",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "ChannelLinkShorteningPayload": [
    "ChannelLinkShortening",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "ChannelMetadata": [
    "BlueskyMetadata",
    "FacebookMetadata",
    "GoogleBusinessMetadata",
    "InstagramMetadata",
    "LinkedInMetadata",
    "MastodonMetadata",
    "PinterestMetadata",
    "TiktokMetadata",
    "TwitterMetadata",
    "WhatsAppMetadata",
    "YoutubeMetadata"
  ],
  "ChannelMutationResponse": [
    "ChannelResponse",
    "Error"
  ],
  "ChannelStoreTemporaryCredentialsResponse": [
    "Error",
    "Response"
  ],
  "ChannelUpdateLockedStatusResponse": [
    "ChannelLimitError",
    "Error",
    "Response"
  ],
  "ChannelsConnectPayload": [
    "ChannelsConnectError",
    "ChannelsConnectResponse"
  ],
  "ChannelsSetRecommendationsPayload": [
    "ChannelsSetRecommendationsError",
    "ChannelsSetRecommendationsResponse"
  ],
  "ChannelsUpdateCredentialsResponse": [
    "Error",
    "Response"
  ],
  "CheckChannelCapabilitiesPayload": [
    "EmptySuccess",
    "LimitReachedError"
  ],
  "ChecklistsPayload": [
    "ChecklistsResponse",
    "CoreWebAppCommonError"
  ],
  "ClaimLinkedInPremiumPromoCodePayload": [
    "ClaimLinkedInPremiumPromoCodeSuccess",
    "VoidMutationError"
  ],
  "ClientPayload": [
    "Client",
    "ClientError"
  ],
  "CollaborationNoteSubjectChange": [
    "CollaborationNoteSubjectNoteChanged",
    "CollaborationNoteSubjectNoteDeleted"
  ],
  "CollaborationNotesChange": [
    "CollaborationNoteCreated",
    "CollaborationNoteDeleted",
    "CollaborationNoteUpdated"
  ],
  "CommentData": [
    "CommentFromBuffer",
    "CommentFromThirdParty"
  ],
  "CommentMetadata": [
    "GoogleBusinessCommentMetadata"
  ],
  "CommentOEmbed": [
    "OEmbedRich"
  ],
  "CommonPostMetadata": [
    "BlueskyPostMetadata",
    "FacebookPostMetadata",
    "GoogleBusinessPostMetadata",
    "InstagramPostMetadata",
    "LinkedInPostMetadata",
    "MastodonPostMetadata",
    "PinterestPostMetadata",
    "StartPagePostMetadata",
    "SubstackPostMetadata",
    "ThreadsPostMetadata",
    "TiktokPostMetadata",
    "TwitterPostMetadata",
    "YoutubePostMetadata"
  ],
  "CompleteEmailVerificationPayload": [
    "CompleteEmailVerificationSuccess",
    "UnexpectedError"
  ],
  "CompleteOnboardingStepPayload": [
    "CompleteOnboardingStepResponse",
    "OnboardingAlreadyCompletedError"
  ],
  "CompleteWhatsAppConnectionPayload": [
    "ChannelConnectionCannotStealChannelError",
    "CompleteWhatsAppConnectionResponse",
    "InvalidInputError",
    "LimitReachedError",
    "NotFoundError"
  ],
  "ConnectableServicesPayload": [
    "ConnectableServicesError",
    "ConnectableServicesResponse"
  ],
  "Content": [
    "ContentItem",
    "Post"
  ],
  "ContentItemBody": [
    "DraftContent",
    "PostContent"
  ],
  "Conversation": [
    "MessageConversation"
  ],
  "ConvertCustomChannelPayload": [
    "ConvertCustomChannelResponse",
    "CustomChannelError"
  ],
  "CoreWebAppError": [
    "CoreWebAppCommonError"
  ],
  "CoreWebAppMutationResponse": [
    "IdeaMutationSuccess",
    "IdeasDeletionSuccess",
    "PlaceholderIdeasMutationSuccess",
    "PostNotFound",
    "PostNotUpdated",
    "PostUpdated",
    "TagActionInIdeasSuccess"
  ],
  "CreateChangelogEntryPayload": [
    "ChangelogEntry",
    "VoidMutationError"
  ],
  "CreateChannelAnalyticsExportPayload": [
    "ChannelAnalyticsExportProcessing",
    "ChannelAnalyticsExportSuccess",
    "InvalidInputError"
  ],
  "CreateChannelGroupPayload": [
    "ChannelGroup",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "CreateCheckoutSessionPayload": [
    "BillingError",
    "CreateCheckoutSessionResponse"
  ],
  "CreateCollaborationNotePayload": [
    "CollaborationNoteThreadClosedError",
    "CreateCollaborationNoteSuccess",
    "InvalidInputError",
    "LimitReachedError"
  ],
  "CreateContentItemDraftPayload": [
    "CreateContentItemDraftFailure",
    "CreateContentItemDraftSuccess"
  ],
  "CreateContentItemError": [
    "CreateContentItemVariantInvalidInputError",
    "CreateContentItemVariantLimitReachedError",
    "CreateContentItemVariantNotFoundError",
    "InvalidInputError",
    "LimitReachedError",
    "NotFoundError"
  ],
  "CreateContentItemPayload": [
    "CreateContentItemFailure",
    "CreateContentItemSuccess"
  ],
  "CreateCustomChannelsPayload": [
    "CreateCustomChannelsResponse",
    "CustomChannelError"
  ],
  "CreateCustomerPortalSessionPayload": [
    "BillingError",
    "CreateCustomerPortalSessionResponse"
  ],
  "CreateIdeaGroupPayload": [
    "IdeaGroup",
    "InvalidInputError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "CreateIdeaPayload": [
    "Idea",
    "IdeaResponse",
    "InvalidInputError",
    "LimitReachedError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "CreateManagedPostTemplatePayload": [
    "CreateManagedPostTemplateSuccess",
    "VoidMutationError"
  ],
  "CreateOrUpdateFeedCollectionPayload": [
    "FeedCollectionActionSuccess",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "CreateOrUpdateFeedPayload": [
    "FeedActionSuccess",
    "FeedConnectionError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "CreatePostGroupPayload": [
    "CreatePostGroupSuccess",
    "InvalidInputError"
  ],
  "CreatePostRecurrencePayload": [
    "PostActionSuccess",
    "VoidMutationError"
  ],
  "CreatePostTemplateCampaignPayload": [
    "CreatePostTemplateCampaignSuccess",
    "InvalidInputError"
  ],
  "CreatePostTemplatePayload": [
    "CreatePostTemplateSuccess",
    "VoidMutationError"
  ],
  "CreateSavedReplyPayload": [
    "DuplicateError",
    "InvalidInputError",
    "LimitReachedError",
    "NotFoundError",
    "SavedReplyActionSuccess",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "CreateSavedViewPayload": [
    "InvalidInputError",
    "LimitReachedError",
    "SavedView"
  ],
  "CreateSnippetPayload": [
    "CreateSnippetSuccess",
    "VoidMutationError"
  ],
  "CreateTagPayload": [
    "DuplicateError",
    "InvalidInputError",
    "LimitReachedError",
    "NotFoundError",
    "RestProxyError",
    "TagActionSuccess",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "CredentialsForChannelsPayload": [
    "CredentialsForChannelsError",
    "CredentialsForChannelsResponse"
  ],
  "CustomChannelUpdatePayload": [
    "CustomChannelUpdateResponse",
    "CustomChannelsError"
  ],
  "CustomChannelsCreatePayload": [
    "CustomChannelsCreateResponse",
    "CustomChannelsError"
  ],
  "Day": [
    "CalendarDay"
  ],
  "DeleteAPIClientPayload": [
    "DeleteAPIClientSuccess",
    "NotFoundError"
  ],
  "DeleteAccountPayload": [
    "DeleteAccountSuccess",
    "InvalidInputError",
    "NotFoundError",
    "UnexpectedError"
  ],
  "DeleteAdminCommentPayload": [
    "EmptySuccess",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "DeleteChangelogEntryPayload": [
    "DeleteChangelogEntrySuccess",
    "VoidMutationError"
  ],
  "DeleteChannelGroupPayload": [
    "DeleteChannelGroupSuccess",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "DeleteCollaborationNotePayload": [
    "DeleteCollaborationNoteSuccess",
    "VoidMutationError"
  ],
  "DeleteContentItemPayload": [
    "DeleteContentItemFailure",
    "EmptySuccess"
  ],
  "DeleteEntityNotePayload": [
    "CoreWebAppCommonError",
    "DeleteEntityNoteResponse"
  ],
  "DeleteFeedCollectionPayload": [
    "FeedCollectionDeleteSuccess",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "DeleteFeedPayload": [
    "DeleteFeedResponse",
    "UnexpectedError"
  ],
  "DeleteIdeaGroupPayload": [
    "DeleteIdeaGroupResponse",
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "DeleteManagedPostTemplatePayload": [
    "EmptySuccess",
    "VoidMutationError"
  ],
  "DeleteNoteFromPostPayload": [
    "DeleteNoteFromPostSuccess",
    "InvalidInputError",
    "LimitReachedError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "DeletePostPayload": [
    "DeletePostSuccess",
    "VoidMutationError"
  ],
  "DeletePostResult": [
    "DeletePostSuccess",
    "NotFoundError",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "DeletePostTemplateCampaignPayload": [
    "EmptySuccess",
    "VoidMutationError"
  ],
  "DeletePostTemplatePayload": [
    "EmptySuccess",
    "VoidMutationError"
  ],
  "DeleteSavedReplyPayload": [
    "DeleteSavedReplySuccess",
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "DeleteSavedViewPayload": [
    "DeleteSavedViewSuccess",
    "NotFoundError"
  ],
  "DeleteSnippetPayload": [
    "DeleteSnippetSuccess",
    "VoidMutationError"
  ],
  "DeleteTagPayload": [
    "DeleteTagActionSuccess",
    "InvalidInputError",
    "NotFoundError",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "DisableTwoFactorWithPasswordPayload": [
    "EmptySuccess",
    "InvalidInputError"
  ],
  "DismissAllCommentsForChannelsPayload": [
    "DismissAllCommentsForChannelsSuccess",
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "DismissAllCommentsPayload": [
    "DismissAllCommentsSuccess",
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "DismissAllEngagementsByChannelIdsPayload": [
    "DismissAllEngagementsByChannelIdsSuccess",
    "VoidMutationError"
  ],
  "DismissBannerPayload": [
    "DismissBannerError",
    "DismissBannerResponse"
  ],
  "DismissBufferHomeTaskPayload": [
    "DismissBufferHomeTaskSuccess",
    "VoidMutationError"
  ],
  "DismissCommentPayload": [
    "DismissCommentSuccess",
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "DismissEngagementPayload": [
    "DismissEngagementSuccess",
    "VoidMutationError"
  ],
  "DowngradeToFreePayload": [
    "UpdateBillingSubscriptionPlanResponse",
    "VoidMutationError"
  ],
  "Draft": [
    "ContentItem",
    "Post"
  ],
  "DropPostPayload": [
    "NotFoundError",
    "PostActionSuccess",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "EditEntityNotePayload": [
    "CoreWebAppCommonError",
    "EditEntityNoteResponse"
  ],
  "EditPostRecurrencePayload": [
    "PostActionSuccess",
    "VoidMutationError"
  ],
  "EmailNotificationPreferencePayload": [
    "EmailNotificationPreferenceError",
    "EmailNotificationPreferencesResponse"
  ],
  "Engagement": [
    "Comment",
    "Mention"
  ],
  "EngagementConversationPost": [
    "Mention",
    "Post"
  ],
  "EngagementMetadata": [
    "GoogleBusinessEngagementMetadata"
  ],
  "EnrollInReferralProgramPayload": [
    "EnrollInReferralProgramSuccess",
    "EnrollInReferralProgramUnavailableError"
  ],
  "ExecuteFreeToolContentPayload": [
    "ContentExtractionFailedError",
    "ExecuteFreeToolContentSuccess",
    "InvalidInputError",
    "LimitReachedError"
  ],
  "FeedConnectionMetadata": [
    "NewsSearchConnectionMetadata",
    "RSSFeedConnectionMetadata"
  ],
  "FeedMoveUpdatesPayload": [
    "FeedMoveUpdatesResponse",
    "UnexpectedError"
  ],
  "ForceCommentsBackfillForChannelPayload": [
    "ForceCommentsBackfillForChannelSuccess",
    "LimitReachedError",
    "VoidMutationError"
  ],
  "FreeToolOutput": [
    "FreeToolAiHashtagGeneratorOutput",
    "FreeToolBlogToSocialMediaPostRepurposerOutput",
    "FreeToolHookGeneratorOutput",
    "FreeToolInstagramBioGeneratorOutput",
    "FreeToolInstagramNameGeneratorOutput",
    "FreeToolLinkedInHeadlineGeneratorOutput",
    "FreeToolSubstackToSocialMediaPostRepurposerOutput",
    "FreeToolTiktokUsernameGeneratorOutput",
    "FreeToolUsernameGeneratorOutput",
    "FreeToolYoutubeNameGeneratorOutput"
  ],
  "GenerateAccessTokenPayload": [
    "GenerateAccessTokenSuccess",
    "InvalidCredentialsError"
  ],
  "GenerateAnonymousMediaUploadFormPayload": [
    "GenerateAnonymousMediaUploadFormSuccess",
    "InvalidInputError",
    "LimitReachedError"
  ],
  "GeneratePersonalAccessTokenPayload": [
    "GeneratePersonalAccessTokenSuccess",
    "InvalidInputError",
    "LimitReachedError"
  ],
  "GenerateTemplatedCompletionPayload": [
    "GenerateTemplatedCompletionSuccess",
    "LimitReachedError",
    "UnexpectedError"
  ],
  "GenerateThreadedPostOptionsPayload": [
    "GenerateThreadedPostOptionsError",
    "GenerateThreadedPostOptionsSuccess"
  ],
  "GenericSubscription": [
    "MPSubscription",
    "OBSubscription"
  ],
  "GetAccessTokensForChannelPayload": [
    "AccessTokens",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError",
    "UnsupportedChannelError"
  ],
  "GetPreviewInvoicePayload": [
    "GetPreviewInvoiceResponse",
    "VoidMutationError"
  ],
  "GetThreadsMostRecentlyUsedTopicsPayload": [
    "GetThreadsMostRecentlyUsedTopicsResponse",
    "InvalidInputError",
    "NotFoundError"
  ],
  "GetTrendingTopicsPayload": [
    "GetTrendingTopicsResponse",
    "InvalidInputError",
    "UnexpectedError"
  ],
  "GoogleBusinessPostDetails": [
    "GoogleBusinessEventMetaData",
    "GoogleBusinessOfferMetaData",
    "GoogleBusinessWhatsNewMetaData"
  ],
  "HellonextSsoMutationResponse": [
    "Error",
    "HellonextSsoResponse",
    "UnverifiedEmailAddressError"
  ],
  "IdeaMutationPayload": [
    "CoreWebAppCommonError",
    "IdeaMutationSuccess"
  ],
  "IdeaPayload": [
    "CoreWebAppCommonError",
    "Idea"
  ],
  "IdeasCountByTagsPayload": [
    "CoreWebAppCommonError",
    "IdeasCountByTags"
  ],
  "IdeasCountPayload": [
    "CoreWebAppCommonError",
    "IdeasCount"
  ],
  "IdeasDeletionPayload": [
    "CoreWebAppCommonError",
    "IdeasDeletionSuccess"
  ],
  "ImageSearchPayload": [
    "ImageSearchError",
    "ImageSearchResponse"
  ],
  "ImpersonationResponse": [
    "Error",
    "Response"
  ],
  "IncreaseSubscriptionQuantityByChannelIdsPayload": [
    "UpdateBillingSubscriptionPlanResponse",
    "VoidMutationError"
  ],
  "InitiateEmailUpdateRequestPayload": [
    "InitiateEmailUpdateRequestSuccess",
    "InvalidInputError",
    "NotFoundError",
    "UnexpectedError"
  ],
  "InitiateOnboardingPayload": [
    "InitiateOnboardingResponse",
    "OnboardingAlreadyCompletedError"
  ],
  "InitiateUpdateEmailPayload": [
    "EmptySuccess",
    "InvalidInputError",
    "NotFoundError",
    "UnexpectedError"
  ],
  "InstagramAudioCatalogPayload": [
    "ChannelRefreshRequired",
    "InstagramAudioCatalogSuccess"
  ],
  "InstagramAudioPayload": [
    "ChannelRefreshRequired",
    "InstagramAudioSuccess"
  ],
  "InstagramAudioPreviewPayload": [
    "ChannelRefreshRequired",
    "InstagramAudioPreviewSuccess"
  ],
  "InviteTeamMembersPayload": [
    "InviteTeamMembersSuccess",
    "TeamMemberLimitReachedError"
  ],
  "KeepSubscriptionActivePayload": [
    "KeepSubscriptionActiveSuccess",
    "VoidMutationError"
  ],
  "LoginVerificationResponsePayload": [
    "EmptySuccess",
    "UnexpectedError"
  ],
  "MarkBufferHomeTaskCompletePayload": [
    "MarkBufferHomeTaskCompleteSuccess",
    "VoidMutationError"
  ],
  "MarkChangelogEntryAsSeenPayload": [
    "MarkChangelogEntryAsSeenSuccess",
    "VoidMutationError"
  ],
  "MarkCollaborationNotesReadPayload": [
    "MarkCollaborationNotesReadSuccess",
    "VoidMutationError"
  ],
  "MarkCollaborationNotesUnreadPayload": [
    "MarkCollaborationNotesUnreadSuccess",
    "VoidMutationError"
  ],
  "MarkNoteAuthorAsDeletedForOrganizationResponse": [
    "MarkNoteAuthorAsDeletedForOrganizationError",
    "MarkNoteAuthorAsDeletedForOrganizationSuccessResponse"
  ],
  "MoveIdeaGroupPayload": [
    "InvalidInputError",
    "MoveIdeaGroupResponse",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "MoveIdeaPayload": [
    "MoveIdeaResponse",
    "UnexpectedError"
  ],
  "MovePostInQueuePayload": [
    "PostActionSuccess",
    "VoidMutationError"
  ],
  "MovePostToDraftsResult": [
    "NotFoundError",
    "PostActionSuccess",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "MutationBasicError": [
    "BasicError",
    "ImageSearchError"
  ],
  "MutationBasicPayload": [
    "BasicError",
    "MutationBasicResponse"
  ],
  "MutationError": [
    "BillingEmailValidationError",
    "CannotRemoveOwnerError",
    "ChannelConnectionCannotStealChannelError",
    "ChannelConnectionNoChannelsError",
    "ChannelConnectionRefreshWrongAccountError",
    "ChannelRefreshRequired",
    "CollaborationNoteThreadClosedError",
    "ContentItemStateError",
    "ConversationChannelPermissionError",
    "ConversationReplySendFailedError",
    "ConversationReplyWindowClosedError",
    "CreateContentItemDraftFailure",
    "CreateContentItemFailure",
    "CreateContentItemVariantInvalidInputError",
    "CreateContentItemVariantLimitReachedError",
    "CreateContentItemVariantNotFoundError",
    "CustomChannelError",
    "DeleteContentItemFailure",
    "DuplicateError",
    "EmailAlreadyMemberError",
    "EnrollInReferralProgramUnavailableError",
    "GenerateThreadedPostOptionsError",
    "InvalidCredentialsError",
    "InvalidEmailError",
    "InvalidInputError",
    "InvalidRedirectUrisError",
    "InvitationAlreadyPendingError",
    "InvitationEmailMismatchError",
    "LastAdminError",
    "LimitReachedError",
    "NotFoundError",
    "OnboardingAlreadyCompletedError",
    "PostChannelNotFoundError",
    "PostInvalidInputError",
    "PostLimitReachedError",
    "PostNotDeletableError",
    "PromoteContentItemDraftToPostsFailure",
    "RemoveSubscriptionScheduleError",
    "RestProxyError",
    "TeamMemberLimitReachedError",
    "TooShortQueryStringError",
    "TransferError",
    "TwoFactorSetupRequiredError",
    "UnauthorizedError",
    "UnexpectedError",
    "UnsupportedChannelError",
    "UpdateContentItemDraftFailure",
    "UpdateContentItemFailure",
    "VideoProcessingError",
    "VoidMutationError"
  ],
  "MutationResponse": [
    "BlockMutationSuccess",
    "BlocksMutationSuccess",
    "CommonMutationError",
    "CommonMutationResponse",
    "StartPageMutationSuccess"
  ],
  "MutationSuccess": [
    "BackfillChannelAnalyticsSuccess",
    "BackfillUpdatesForGridResponse",
    "CancelTrialResponse",
    "DeleteAccountSuccess",
    "EmptySuccess",
    "InitiateEmailUpdateRequestSuccess",
    "RemoveAccountSuccess",
    "RemoveLegacyGlobalFeatureFlipSuccess",
    "SetPasswordSuccess",
    "StartTrialResponse",
    "UpdateAccountAvatarSuccess",
    "UpdateAccountNameSuccess",
    "UpdateCustomerIOAttributesSuccess",
    "UpdateLastActivityAtForChannelSuccess",
    "UpdateStartOfWeekPreferenceSuccess",
    "UpdateTimeFormatPreferenceSuccess",
    "VerifyAccountLoginSuccess",
    "VerifyPasswordSuccess"
  ],
  "OnboardingStep": [
    "IntroductionStep",
    "SurveyStep",
    "TourStep"
  ],
  "OptimizePostingSchedulePayload": [
    "InvalidInputError",
    "NotFoundError",
    "OptimizePostingScheduleResponse",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "OrderChannelForAccountPayload": [
    "EmptySuccess",
    "NotFoundError",
    "UnexpectedError"
  ],
  "OrganizationActivitySummaryPayload": [
    "OrganizationActivitySummary",
    "OrganizationActivitySummaryDefaultState"
  ],
  "OrganizationFeatureUsageUpdateResponse": [
    "Error",
    "Response"
  ],
  "PaymentMethodDetails": [
    "AlipayPaymentMethodDetails",
    "AmazonPayPaymentMethodDetails",
    "BankPaymentMethodDetails",
    "CardPaymentMethodDetails",
    "CashAppPaymentMethodDetails",
    "LinkPaymentMethodDetails"
  ],
  "PlaceholderIdeasCreatedPayload": [
    "CoreWebAppCommonError",
    "PlaceholderIdeasMutationSuccess"
  ],
  "PlanDiscount": [
    "AmountDiscount",
    "PercentDiscount"
  ],
  "PostActionPayload": [
    "InvalidInputError",
    "LimitReachedError",
    "NotFoundError",
    "PostActionSuccess",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "PostMetadata": [
    "BlueskyPostMetadata",
    "FacebookPostMetadata",
    "GoogleBusinessPostMetadata",
    "InstagramPostMetadata",
    "LinkedInPostMetadata",
    "MastodonPostMetadata",
    "PinterestPostMetadata",
    "StartPagePostMetadata",
    "SubstackPostMetadata",
    "ThreadsPostMetadata",
    "TiktokPostMetadata",
    "TwitterPostMetadata",
    "YoutubePostMetadata"
  ],
  "PostStatisticsV2": [
    "PostMetricLegacy",
    "PostMetricObject"
  ],
  "PostUpdatedPayload": [
    "CoreWebAppCommonError",
    "PostNotFound",
    "PostNotUpdated",
    "PostUpdated"
  ],
  "PromoteAnonymousUploadPayload": [
    "InvalidInputError",
    "PromoteAnonymousUploadSuccess"
  ],
  "PromoteContentItemDraftToPostsError": [
    "ContentItemStateError",
    "InvalidInputError",
    "PostChannelNotFoundError",
    "PostInvalidInputError",
    "PostLimitReachedError"
  ],
  "PromoteContentItemDraftToPostsPayload": [
    "PromoteContentItemDraftToPostsFailure",
    "PromoteContentItemDraftToPostsSuccess"
  ],
  "PublicInsightsSamplePayload": [
    "LimitReachedError",
    "PublicInsightsSampleInvalidInput",
    "PublicInsightsSampleSuccess",
    "PublicInsightsSampleUnavailable"
  ],
  "PublishPostNowPayload": [
    "NotFoundError",
    "PostActionSuccess",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError",
    "VideoProcessingError"
  ],
  "PublishingPostAttachment": [
    "PublishingPostDestinationUrl",
    "PublishingPostFirstComment",
    "PublishingPostLink",
    "PublishingPostRetweet"
  ],
  "PushNotificationPreferencePayload": [
    "PushNotificationPreferenceError",
    "PushNotificationPreferencesResponse"
  ],
  "ReactToCollaborationNotePayload": [
    "InvalidInputError",
    "LimitReachedError",
    "ReactToCollaborationNoteSuccess"
  ],
  "ReactToCommentPayload": [
    "InvalidInputError",
    "NotFoundError",
    "ReactToCommentSuccess",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "ReactToEngagementPayload": [
    "ReactToEngagementSuccess",
    "VoidMutationError"
  ],
  "ReactionVisual": [
    "IconVisual",
    "ImageVisual"
  ],
  "ReferralProgramStatus": [
    "ReferralProgramEnrolled",
    "ReferralProgramUnavailable",
    "ReferralProgramUnenrolled"
  ],
  "RefreshChannelTakeawaysPayload": [
    "InvalidInputError",
    "RefreshChannelTakeawaysSuccess"
  ],
  "RefreshCrossChannelsTakeawaysPayload": [
    "InvalidInputError",
    "RefreshCrossChannelsTakeawaysSuccess"
  ],
  "RefreshFeedCollectionPayload": [
    "FeedCollectionActionSuccess",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "RefreshFeedPayload": [
    "FeedActionSuccess",
    "FeedConnectionError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "RegisterAPIClientPayload": [
    "InvalidRedirectUrisError",
    "LimitReachedError",
    "NotFoundError",
    "RegisterAPIClientSuccess"
  ],
  "RejectPostPayload": [
    "NotFoundError",
    "PostActionSuccess",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "RemoveAccountPayload": [
    "InvalidInputError",
    "NotFoundError",
    "RemoveAccountSuccess",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "RemoveLegacyGlobalFeatureFlipPayload": [
    "InvalidInputError",
    "NotFoundError",
    "RemoveLegacyGlobalFeatureFlipSuccess",
    "UnexpectedError"
  ],
  "RemovePostFromContentItemPayload": [
    "RemovePostFromContentItemSuccess",
    "VoidMutationError"
  ],
  "RemovePostScheduledTimePayload": [
    "PostActionSuccess",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "RemoveSubscriptionSchedulePayload": [
    "RemoveSubscriptionScheduleError",
    "RemoveSubscriptionScheduleResponse"
  ],
  "RemoveTeamMemberPayload": [
    "CannotRemoveOwnerError",
    "EmptySuccess",
    "LastAdminError",
    "NotFoundError"
  ],
  "ReorderPostsPayload": [
    "NotFoundError",
    "ReorderPostsSuccess",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "ReorderSavedViewsPayload": [
    "InvalidInputError",
    "SavedViewsResponse"
  ],
  "ReplyToCommentPayload": [
    "InvalidInputError",
    "NotFoundError",
    "ReplyToCommentSuccess",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "ReplyToConversationPayload": [
    "ChannelRefreshRequired",
    "ConversationChannelPermissionError",
    "ConversationReplySendFailedError",
    "ConversationReplyWindowClosedError",
    "InvalidInputError",
    "ReplyToConversationSuccess",
    "VoidMutationError"
  ],
  "ReplyToEngagementPayload": [
    "ReplyToEngagementSuccess",
    "VoidMutationError"
  ],
  "RequestPostApprovalPayload": [
    "NotFoundError",
    "PostActionSuccess",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "ResendInvitationPayload": [
    "NotFoundError",
    "ResendInvitationSuccess"
  ],
  "ResendLoginVerificationNotificationPayload": [
    "EmptySuccess",
    "VoidMutationError"
  ],
  "ResetAPIClientUsagePayload": [
    "NotFoundError",
    "ResetAPIClientUsageSuccess"
  ],
  "ResetOnboardingFlowPayload": [
    "ResetOnboardingFlowResponse",
    "VoidMutationError"
  ],
  "ResolveConversationPayload": [
    "ConversationMutationSuccess",
    "VoidMutationError"
  ],
  "RevertPostApprovalRequestPayload": [
    "NotFoundError",
    "PostActionSuccess",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "RevokeAccessConnectedAppPayload": [
    "EmptySuccess",
    "UnexpectedError"
  ],
  "RevokeClientPersonalAccessTokensPayload": [
    "NotFoundError",
    "RevokeClientPersonalAccessTokensSuccess"
  ],
  "RevokeInvitationPayload": [
    "EmptySuccess",
    "NotFoundError"
  ],
  "RevokePersonalAccessTokenPayload": [
    "InvalidInputError",
    "RevokePersonalAccessTokenSuccess"
  ],
  "SchedulePostPayload": [
    "LimitReachedError",
    "NotFoundError",
    "PostActionSuccess",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "SchedulesPayload": [
    "SchedulesError",
    "SchedulesResponse"
  ],
  "ScrapedLink": [
    "LinkAttachment",
    "RetweetMetadata"
  ],
  "SearchInstagramAudioPayload": [
    "ChannelRefreshRequired",
    "SearchInstagramAudioSuccess"
  ],
  "SearchThreadsLocationsPayload": [
    "ChannelRefreshRequired",
    "SearchThreadsLocationsResponse",
    "TooShortQueryStringError"
  ],
  "SendTestNotificationPayload": [
    "SendTestNotificationError",
    "SendTestNotificationSuccess"
  ],
  "SetBetaFeatureStatePayload": [
    "EmptySuccess"
  ],
  "SetChannelCapabilityToDisplayOnNetworkPayload": [
    "EmptySuccess",
    "VoidMutationError"
  ],
  "SetPasswordForAccountPayload": [
    "InvalidInputError",
    "NotFoundError",
    "SetPasswordSuccess",
    "UnexpectedError"
  ],
  "SetPostingScheduleForChannelPayload": [
    "InvalidInputError",
    "NotFoundError",
    "SetPostingScheduleForChannelResponse",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "SetTakeawayFeedbackPayload": [
    "SetTakeawayFeedbackSuccess",
    "VoidMutationError"
  ],
  "SetTrustedPartnerPayload": [
    "EmptySuccess",
    "VoidMutationError"
  ],
  "ShopGridCustomLinksMutationPayload": [
    "NotFoundError",
    "ShopGridCustomLinksPayload",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "StartPageBlock": [
    "StartPageBlockButtonLink",
    "StartPageBlockFeed",
    "StartPageBlockFeedPost",
    "StartPageBlockHeader",
    "StartPageBlockIconLinks",
    "StartPageBlockImageLink",
    "StartPageBlockImageLinksGrid",
    "StartPageBlockInstagramLinksGrid",
    "StartPageBlockMailchimp",
    "StartPageBlockSpotify",
    "StartPageBlockSubHeading",
    "StartPageBlockText",
    "StartPageBlockVideo"
  ],
  "StartPageMutationResponse": [
    "CommonError",
    "StartPageMutationSuccess"
  ],
  "StartPageResponse": [
    "CommonError",
    "StartPage"
  ],
  "StartPagesResponse": [
    "CommonError",
    "StartPages"
  ],
  "StartTrialPayload": [
    "StartTrialResponse",
    "VoidMutationError"
  ],
  "SubmitProductFeedbackPayload": [
    "SubmitProductFeedbackSuccess",
    "VoidMutationError"
  ],
  "SupportedReaction": [
    "DefaultReaction",
    "LinkedInReaction"
  ],
  "SwapPostsInQueuePayload": [
    "NotFoundError",
    "RestProxyError",
    "SwapPostsInQueueSuccess",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "SwitchBillingGatewayPayload": [
    "InvalidInputError",
    "SwitchBillingGatewayResponse"
  ],
  "SyncConfiguration": [
    "PollingSyncConfiguration"
  ],
  "TagActionInIdeasPayload": [
    "CoreWebAppCommonError",
    "TagActionInIdeasSuccess"
  ],
  "TextGenerationResponse": [
    "CommonError",
    "TextGenerated"
  ],
  "ThreadedPostMetadata": [
    "BlueskyPostMetadata",
    "MastodonPostMetadata",
    "ThreadsPostMetadata",
    "TwitterPostMetadata"
  ],
  "ToggleChannelCapabilitySynchronizationPayload": [
    "EmptySuccess",
    "VoidMutationError"
  ],
  "TrackExternalServiceUsageResponse": [
    "Error",
    "Response"
  ],
  "TransferOrganizationOwnershipPayload": [
    "EmptySuccess",
    "TransferError"
  ],
  "TwoFactorConfirmPayload": [
    "InvalidInputError",
    "TwoFactorConfirmResponse",
    "UnexpectedError"
  ],
  "TwoFactorDisablePayload": [
    "EmptySuccess",
    "UnexpectedError"
  ],
  "TwoFactorRecoveryCodePayload": [
    "InvalidInputError",
    "TwoFactorRecoveryCodeResponse",
    "UnexpectedError"
  ],
  "TwoFactorRequestOneTimePasswordPayload": [
    "EmptySuccess",
    "UnexpectedError"
  ],
  "TwoFactorSetupPayload": [
    "InvalidInputError",
    "TwoFactorSetupResponse",
    "UnexpectedError"
  ],
  "UndismissCommentPayload": [
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UndismissCommentSuccess",
    "UnexpectedError"
  ],
  "UndismissEngagementPayload": [
    "UndismissEngagementSuccess",
    "VoidMutationError"
  ],
  "UnresolveConversationPayload": [
    "ConversationMutationSuccess",
    "VoidMutationError"
  ],
  "UpdateAPIClientPayload": [
    "InvalidInputError",
    "InvalidRedirectUrisError",
    "NotFoundError",
    "UpdateAPIClientSuccess"
  ],
  "UpdateAPIClientSuspensionStatusPayload": [
    "NotFoundError",
    "UpdateAPIClientSuspensionStatusSuccess"
  ],
  "UpdateAccountAvatarPayload": [
    "InvalidInputError",
    "NotFoundError",
    "UnexpectedError",
    "UpdateAccountAvatarSuccess"
  ],
  "UpdateAccountNamePayload": [
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError",
    "UpdateAccountNameSuccess"
  ],
  "UpdateAccountPreferencesPayload": [
    "InvalidInputError",
    "UpdateAccountPreferencesSuccess"
  ],
  "UpdateAccountTimezonePayload": [
    "InvalidInputError",
    "NotFoundError",
    "UnexpectedError",
    "UpdateAccountTimezoneSuccess"
  ],
  "UpdateAdminCommentPayload": [
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError",
    "UpdateAdminCommentSuccess"
  ],
  "UpdateBillingSubscriptionPlanPayload": [
    "UpdateBillingSubscriptionPlanResponse",
    "VoidMutationError"
  ],
  "UpdateChangelogEntryPayload": [
    "ChangelogEntry",
    "VoidMutationError"
  ],
  "UpdateChannelGroupPayload": [
    "ChannelGroup",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "UpdateChannelMemberPermissionsPayload": [
    "NotFoundError",
    "UpdateChannelMemberPermissionsSuccess"
  ],
  "UpdateChannelPermissionsPayload": [
    "NotFoundError",
    "UpdateChannelPermissionsSuccess"
  ],
  "UpdateChannelPostingGoalPayload": [
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError",
    "UpdateChannelPostingGoalResponse"
  ],
  "UpdateCollaborationNotePayload": [
    "InvalidInputError",
    "UpdateCollaborationNoteSuccess"
  ],
  "UpdateContentItemDraftError": [
    "ContentItemStateError",
    "InvalidInputError"
  ],
  "UpdateContentItemDraftPayload": [
    "UpdateContentItemDraftFailure",
    "UpdateContentItemDraftSuccess"
  ],
  "UpdateContentItemPayload": [
    "UpdateContentItemFailure",
    "UpdateContentItemSuccess"
  ],
  "UpdateCustomChannelPayload": [
    "CustomChannelError",
    "UpdateCustomChannelResponse"
  ],
  "UpdateCustomLinksColorsPayload": [
    "EmptySuccess",
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "UpdateCustomerIOAttributesPayload": [
    "UpdateCustomerIOAttributesSuccess",
    "VoidMutationError"
  ],
  "UpdateFeedPayload": [
    "FeedActionSuccess",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "UpdateIdeaGroupPayload": [
    "IdeaGroup",
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "UpdateIdeaPayload": [
    "IdeaResponse",
    "InvalidInputError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "UpdateLastActivityAtForChannelPayload": [
    "UnauthorizedError",
    "UnexpectedError",
    "UpdateLastActivityAtForChannelSuccess"
  ],
  "UpdateManagedPostTemplatePayload": [
    "UpdateManagedPostTemplateSuccess",
    "VoidMutationError"
  ],
  "UpdateNoteOnPostPayload": [
    "InvalidInputError",
    "LimitReachedError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError",
    "UpdateNoteOnPostSuccess"
  ],
  "UpdateOrganizationBillingEmailPayload": [
    "BillingEmailValidationError",
    "UpdateOrganizationBillingEmailSuccess"
  ],
  "UpdateOrganizationEnforce2FAPayload": [
    "EmptySuccess",
    "VoidMutationError"
  ],
  "UpdatePasswordPayload": [
    "EmptySuccess",
    "InvalidInputError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "UpdatePostDueAtMutationResponse": [
    "CoreWebAppCommonError",
    "PostNotFound",
    "PostNotUpdated",
    "PostUpdated"
  ],
  "UpdatePostTagsPayload": [
    "NotFoundError",
    "PostActionSuccess",
    "RestProxyError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "UpdatePostTemplateCampaignPayload": [
    "InvalidInputError",
    "NotFoundError",
    "UpdatePostTemplateCampaignSuccess"
  ],
  "UpdatePostTemplatePayload": [
    "UpdatePostTemplateSuccess",
    "VoidMutationError"
  ],
  "UpdateSavedReplyPayload": [
    "DuplicateError",
    "InvalidInputError",
    "NotFoundError",
    "SavedReplyActionSuccess",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "UpdateSavedViewPayload": [
    "InvalidInputError",
    "NotFoundError",
    "SavedView"
  ],
  "UpdateShopGridPostLinkPayload": [
    "EmptySuccess",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "UpdateSnippetPayload": [
    "UpdateSnippetSuccess",
    "VoidMutationError"
  ],
  "UpdateStartOfWeekPreferencePayload": [
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError",
    "UpdateStartOfWeekPreferenceSuccess"
  ],
  "UpdateSubscriptionQuantityPayload": [
    "UpdateBillingSubscriptionPlanResponse",
    "VoidMutationError"
  ],
  "UpdateTagPayload": [
    "DuplicateError",
    "InvalidInputError",
    "NotFoundError",
    "RestProxyError",
    "TagActionSuccess",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "UpdateTeamMemberRolePayload": [
    "LastAdminError",
    "NotFoundError",
    "UpdateTeamMemberRoleSuccess"
  ],
  "UpdateTimeFormatPreferencePayload": [
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError",
    "UpdateTimeFormatPreferenceSuccess"
  ],
  "UpdateTimezoneForChannelPayload": [
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError",
    "UpdateTimezoneForChannelResponse"
  ],
  "UpdateTrendingTopicSuggestionsVisibilityPayload": [
    "InvalidInputError",
    "NotFoundError",
    "UpdateTrendingTopicSuggestionsVisibilitySuccess"
  ],
  "UpgradePlanToAnnualBillingPayload": [
    "BillingError",
    "UpgradePlanToAnnualBillingResponse"
  ],
  "UploadPayload": [
    "CoreWebAppCommonError",
    "UploadDetails"
  ],
  "ValidateAPIClientNamePayload": [
    "InvalidInputError",
    "ValidateAPIClientNameSuccess"
  ],
  "ValidationRule": [
    "CountRule",
    "DurationRule",
    "ExclusiveRule",
    "FileSizeRule",
    "FormatRule",
    "LengthRule",
    "RequiresRule"
  ],
  "VerifyAccountLoginPayload": [
    "VerifyAccountLoginSuccess",
    "VoidMutationError"
  ],
  "VerifyPasswordPayload": [
    "InvalidInputError",
    "NotFoundError",
    "UnauthorizedError",
    "UnexpectedError",
    "VerifyPasswordSuccess"
  ],
  "VerifyTfaCodePayload": [
    "InvalidInputError",
    "MutationBasicResponse",
    "NotFoundError",
    "UnexpectedError"
  ],
  "WhatsAppConnectionInfoPayload": [
    "InvalidInputError",
    "LimitReachedError",
    "NotFoundError",
    "WhatsAppConnectionInfoResponse"
  ],
  "accountSetSettingsPayload": [
    "AccountSetSettingsError",
    "AccountSetSettingsResponse"
  ],
  "trackActionOnboardingSurveyPayload": [
    "InvalidInputError",
    "TrackActionOnboardingSurveySuccess",
    "UnauthorizedError",
    "UnexpectedError"
  ],
  "voteForFeatureMutationResponse": [
    "BasicError",
    "MutationBasicResponse"
  ]
}
